module.exports = __webpack_public_path__ + "assets/img/perbg.02dcee27.png";